import { Phone, Mail, MapPin, Facebook, Instagram, Youtube } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-[#fdf4e9] text-[#7a4a26] pt-8 md:pt-10 pb-4 md:pb-6">
      {/* MAIN GRID */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 px-4 sm:px-6 text-sm">
        
        {/* BRAND - Full width on mobile, then normal */}
        <div className="sm:col-span-2 lg:col-span-1">
          <h2 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent">
            Purohit App
          </h2>
          <p className="mt-1 text-base font-semibold">Purohit Services</p>
          <p className="mt-3 leading-relaxed max-w-xs text-xs sm:text-sm">
            For every pooja prayer promise – bringing devotion to your doorstep.
          </p>
        </div>

        {/* SERVICES - Responsive ordering */}
        <div className="mt-4 sm:mt-0">
          <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3">Services</h3>
          <ul className="space-y-1.5">
            <li className="hover:text-orange-600 cursor-pointer text-sm sm:text-base">Find Purohits</li>
           
            <li className="hover:text-orange-600 cursor-pointer text-sm sm:text-base">Consultations</li>
          </ul>
        </div>

        {/* SUPPORT */}
        <div className="mt-4 sm:mt-0">
          <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3">Support</h3>
          <ul className="space-y-1.5">
            <li className="hover:text-orange-600 cursor-pointer text-sm sm:text-base">Help Center</li>
            <li className="hover:text-orange-600 cursor-pointer text-sm sm:text-base">How it Works</li>
            
            <li className="hover:text-orange-600 cursor-pointer text-sm sm:text-base">Become a Purohit</li>
          </ul>
        </div>

        {/* CONTACT - Full width on mobile, then normal */}
        <div className="mt-4 sm:mt-0 sm:col-span-2 lg:col-span-1">
          <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3">Stay Connected</h3>

          <div className="space-y-2 sm:space-y-3">
            <a href="tel:+919876543210" className="flex items-center gap-2 hover:text-orange-600 text-sm sm:text-base">
              <span className="p-1 sm:p-1.5 bg-orange-100 rounded-lg">
                <Phone className="text-orange-600" size={14} />
              </span>
              +91 98765 43210
            </a>

            <a href="mailto:support@purohitapp.com" className="flex items-center gap-2 hover:text-orange-600 text-sm sm:text-base">
              <span className="p-1 sm:p-1.5 bg-orange-100 rounded-lg">
                <Mail className="text-orange-600" size={14} />
              </span>
              support@purohitapp.com
            </a>

            <a
              href="https://maps.google.com/?q=Bengaluru+JP+Nagar"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-orange-600 text-sm sm:text-base"
            >
              <span className="p-1 sm:p-1.5 bg-orange-100 rounded-lg">
                <MapPin className="text-orange-600" size={14} />
              </span>
              Bengaluru, J P Nagar
            </a>
          </div>

          {/* SOCIAL ICONS */}
          <div className="flex gap-2 sm:gap-3 mt-4 sm:mt-5">
            <a href="#" className="p-1.5 sm:p-2 bg-blue-600 rounded-lg text-white hover:opacity-90 transition-opacity">
              <Facebook size={14} sm:size={16} />
            </a>
            <a href="#" className="p-1.5 sm:p-2 bg-green-500 rounded-lg text-white hover:opacity-90 transition-opacity">
              <FaWhatsapp size={14} sm:size={16} />
            </a>
            <a
              href="#"
              className="p-1.5 sm:p-2 rounded-lg hover:opacity-90 transition-opacity"
              style={{
                background: "linear-gradient(45deg,#feda75,#fa7e1e,#d62976,#962fbf,#4f5bd5)",
              }}
            >
              <Instagram size={14} sm:size={16} className="text-white" />
            </a>
            <a href="#" className="p-1.5 sm:p-2 bg-red-600 rounded-lg text-white hover:opacity-90 transition-opacity">
              <Youtube size={14} sm:size={16} />
            </a>
          </div>
        </div>
      </div>

      {/* COPYRIGHT + DOWNLOAD */}
      <div className="border-t border-[#e8d9c7] mt-6 sm:mt-8 pt-4 md:pt-6 px-4 text-center">
        {/* Smaller Text */}
        <p className="text-xs mb-1 sm:mb-2">
          © 2025 Purohit App. All rights reserved.
        </p>

        <p className="text-xs sm:text-sm font-medium mb-3 sm:mb-4">
          Download Now:
        </p>

        {/* Buttons - Stack on small screens, row on larger */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4 flex-wrap">
          <a
            href="https://www.apple.com/in/app-store/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 w-32 sm:w-auto hover:opacity-90 transition-opacity"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              className="h-6 sm:h-7 w-full sm:w-auto"
              alt="Download on App Store"
            />
          </a>

          <a
            href="https://play.google.com/store"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 w-32 sm:w-auto hover:opacity-90 transition-opacity"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              className="h-6 sm:h-7 w-full sm:w-auto"
              alt="Get it on Google Play"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}